import React from 'react';
import './GaugeWidget.css';

const GaugeWidget = ({ data }) => {
    const { value, min = 0, max = 100 } = data;
    const percentage = ((value - min) / (max - min)) * 100;
    const rotation = (percentage / 100) * 180 - 90;

    const getColor = () => {
        if (percentage < 33) return '#d13438';
        if (percentage < 66) return '#f7b500';
        return '#498205';
    };

    return (
        <div className="gauge-widget">
            <div className="gauge-container">
                <svg viewBox="0 0 200 120" className="gauge-svg">
                    {/* Background arc */}
                    <path
                        d="M 20 100 A 80 80 0 0 1 180 100"
                        fill="none"
                        stroke="#e1e1e1"
                        strokeWidth="20"
                    />
                    {/* Value arc */}
                    <path
                        d="M 20 100 A 80 80 0 0 1 180 100"
                        fill="none"
                        stroke={getColor()}
                        strokeWidth="20"
                        strokeDasharray={`${percentage * 2.51} 251`}
                    />
                    {/* Needle */}
                    <g transform={`rotate(${rotation} 100 100)`}>
                        <line x1="100" y1="100" x2="100" y2="30" stroke="#323130" strokeWidth="3" />
                        <circle cx="100" cy="100" r="5" fill="#323130" />
                    </g>
                </svg>
            </div>
            <div className="gauge-value">{value}</div>
            <div className="gauge-range">{min} - {max}</div>
        </div>
    );
};

export default GaugeWidget;
